module.exports = __webpack_public_path__ + "img/codigo api correios 1.0210be73.png";